export default __webpack_public_path__ + "static/media/045-home.caa032c7.png";